import { message } from 'antd'

import { fetchUtil as fetch, buildQuery } from 'src/utils/fetch'
import { saveAuditData } from 'src/api/audit'

export const get = async () => {
  try {
    const { data } = await fetch('/misc/faq/admin', {
      headers: {
        role: 'ADMIN',
      },
    })
    return data
  } catch (e) {
    message.error('Get Faq error!')
  }
}

export const deleteFaq = async (item) => {
  try {
    const { data } = await fetch(`/misc/faq/${item.id}`, {
      method: 'DELETE',
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData('DELETE', 'FAQ', item.faq_translations['en'].name)
    return 'success'
  } catch (e) {
    message.error('Get Faq Delete error!')
    return 'failure'
  }
}

export const save = async (payload) => {
  try {
    const { data } = await fetch('/misc/faq/save', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        role: 'ADMIN',
      },
    })
    if (payload.type === 'faq') {
      if (payload.id === undefined)
        saveAuditData('ADD', 'FAQ', payload.category)
      else saveAuditData('EDIT', 'FAQ', payload.title)
    } else {
      saveAuditData('EDIT', 'FAQ-Caetegory', payload.category)
    }
    return 'success'
  } catch (e) {
    message.error('Save Faq error!')
    return 'failure'
  }
}
